<template>
  <v-app>
    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer"> </v-app-bar-nav-icon>
      <v-img
        class="mx-2"
        src="@/assets/Bradbury_Finance_LOGO.png"
        max-height="52"
        contain
        position="left"
      ></v-img>
      <v-spacer></v-spacer>
      <!-- <v-btn
        depressed
        class="mr-1"
        @click="createEmailTemplate()"
        color="black"
        dark
        center
        >Email Stuff</v-btn
      > -->
      <v-btn @click="authSignOut()" dark color="green" center>Signout</v-btn>
    </v-app-bar>
    <v-main fluid fill-height>
      <slot />
    </v-main>
    <v-navigation-drawer v-model="drawer" app>
      <v-list nav>
        <v-list-item-group
          v-model="group"
          active-class="green--text text--accent-4"
        >
          <!-- <v-list-item @click="changePageDashboard">
            <v-list-item-icon>
              <v-icon>mdi-home-analytics</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item> -->
          <v-list-item @click="changePageAdminApplications">
            <v-list-item-icon>
              <v-icon>mdi-form-select</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Applications</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changePageAdminCompanies">
            <v-list-item-icon>
              <v-icon>mdi-home-city-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Companies</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changePageAdminLoanTypes">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Loan Types</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <!-- <template v-slot:append>
        <div class="pa-2 text-center">
          <v-btn to="/" dark color="green" center>Back to Landing</v-btn>
        </div>
      </template> -->
    </v-navigation-drawer>
    <voeter :showLegal="false" />
  </v-app>
</template>

<script>
import Footer from "@/components/Footer";
import { Auth } from "aws-amplify";
// import { Predicates } from '@aws-amplify/datastore';
// import { DataStore, syncExpression } from "aws-amplify";
// import { Company, CompanyLoanType, LoanApplication, Employee } from "@/models";

export default {
  name: "AdminLayout",
  data: () => ({
    drawer: false,
    group: null,
  }),

  async created() {
    // this.$vuetify.theme.light = true;
    // await DataStore.stop();
    // DataStore.configure({
    //   syncExpressions: [
    //     syncExpression(LoanApplication, () => {
    //       return Predicates.ALL;
    //     }),
    //     syncExpression(Company, () => {
    //       return Predicates.ALL;
    //     }),
    //     syncExpression(CompanyLoanType, () => {
    //       return Predicates.ALL;
    //     }),
    //     syncExpression(Employee, () => {
    //       return Predicates.ALL;
    //     }),
    //   ],
    // });
    // await DataStore.start();
  },
  components: {
    voeter: Footer, //footer is reserved, using something else
  },
  methods: {
    changePageDashboard() {
      this.drawer = !this.drawer;
      this.$router.push("/admin/dashboard");
    },
    changePageAdminApplications() {
      this.drawer = !this.drawer;
      this.$router.push("/admin/applications");
    },
    changePageAdminCompanies() {
      this.drawer = !this.drawer;
      this.$router.push("/admin/companies");
    },
    changePageAdminLoanTypes() {
      this.drawer = !this.drawer;
      this.$router.push("/admin/loan-types");
    },
    // signOut() {
    //   this.$store.dispatch("auth/signOut");
    // },
    async authSignOut() {
      await Auth.signOut();
      // .then(() => {
      //   this.$router.push("/");
      // })
      // .catch((err) => {
      //   console.log(err);
      // });

      window.location.href = "/";
    },
    // createEmailTemplate() {
    //   const AWS = require("aws-sdk");
    //   AWS.config.update({
    //     region: "eu-west-2",
    //   });
    //   var ses = new AWS.SES();
    //   var params = {
    //     Template: {
    //       TemplateName: "LoanApplicationTemplate",
    //       SubjectPart: "New Bradbury Assist Application",
    //       TextPart: `Company: {{companyName}}
    // Employee: {{employeeName}}
    // View Application: {{applicationLink}}
    // Download Attachments: {{attachmentsLink}}`,
    //       HtmlPart:
    //         "<p>Company: {{companyName}}</p><p>Employee: {{employeeName}}</p><p>View Application: <a href='{{applicationLink}}'>{{applicationLink}}</a></p><p>Download Attachments: <a href='{{attachmentsLink}}'>{{attachmentsLink}}</a></p>",
    //     },
    //   };
    //   ses.createTemplate(params, function (err, data) {
    //     if (err) console.log(err, err.stack);
    //     else console.log(data);
    //   });
    // },
  },
  // beforeDestroy() {
  //   // this.unsubscribeAuth();
  //   if (this.subscription) {
  //     this.subscription.unsubscribe();
  //   }
  // },
};
</script>
